export const hcpDcrModalContentStyles = {
	root: {
		display: 'flex',
		flexDirection: 'column',
		gap: 3
	}
};
